const CalculateDaysBetweenDateStamps = ({ startDate, endDate }) => {
  if (!(startDate && endDate)) return "";
  const startDateStamp = startDate?.seconds ? startDate.seconds : Date.parse(startDate) / 1000;
  const endDateStamp = endDate?.seconds ? endDate.seconds : Date.parse(endDate) / 1000;
  return Math.abs(Math.round((Number(endDateStamp) - Number(startDateStamp)) / (60 * 60 * 24)));
};

export default CalculateDaysBetweenDateStamps;
